import makeStyles from '@mui/styles/makeStyles';

import { HEADER_HEIGHT_DESKTOP } from '@/config/layout';

import { colors } from '@/themesConfig/colors';

export const useStyles = makeStyles(
  (theme) => ({
    header: {
      position: 'relative',
      justifyContent: 'center',
      height: HEADER_HEIGHT_DESKTOP,
      backgroundColor: colors.black,
    },

    toolbar: {
      display: 'flex',
      justifyContent: 'space-around',

      [theme.breakpoints.down('tablet')]: {
        justifyContent: 'space-between',
      },
    },

    headerButtons: {
      display: 'flex',
      gap: theme.spacing(1),
    },

    getStartedButton: {
      [theme.breakpoints.down('mobile')]: {
        display: 'none',
      },
    },
  }),
  {
    name: 'LandingHeader',
  },
);
